import script from "./new.vue?vue&type=script&setup=true&lang=js"
export * from "./new.vue?vue&type=script&setup=true&lang=js"

import "./new.vue?vue&type=style&index=0&id=0a0b4dce&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a0b4dce"]])

export default __exports__